import { Component, EventEmitter, Input, input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderEntryService } from '../../../../services/order-entry.service';
import { ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableComponent } from '../../../components/table/table.component';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../../../environments/environment';
import { MyMonitoringService } from '../../../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { RadioButtonComponent } from '../../../components/radiobutton/radiobutton.component';
import { ActivatedRoute } from '@angular/router';
import { TextinputComponent } from '../../../components/textinput/textinput.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { RequestPayload } from '../.././order-entry.model';
import { SSNMaskerDirective } from '../../../helper/ssn-mask.directive';
import { PhoneFormatDirective } from '../../../helper/phone-format.directive';
import { AbstractControl, FormBuilder, FormsModule, NgForm } from '@angular/forms';
import { CityLoadData, OrderTypeData, OrderEntryResponse } from '../../../interfaces/OrderEntryRecords';
import { ReconnectComponent } from '../../../reconnect/reconnect.component';
import { DatePipe } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { ControlUtils } from '../../../utils/control-utils';
import { Validator } from '../../../utils/validator';
import { NumberinputComponent } from '../../../components/numberinput/numberinput.component';

import { ApiService } from '../../../../services/apiservice';
import { OrderEntrySharedService } from '../../../../services/order-entry-shared.service';
import { DatePickerModule } from 'primeng/datepicker';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
@Component({
  selector: 'app-move-in-form',
  imports: [DialogModule, TableModule, DatePickerModule,
    TextinputComponent, TabsModule, ToastModule, CommonModule, TagModule,
    ButtonModule, SSNMaskerDirective, InputTextModule, FormsModule,
    ProgressSpinnerModule, FormsModule, DropdownComponent, DatePickerModule, CheckboxModule, RadioButtonComponent, DividerModule, NumberinputComponent],
  providers: [MessageService, OrderEntryService, MyMonitoringService, DatePipe],
  templateUrl: './move-in-form.component.html',
  styleUrl: './move-in-form.component.scss',
  standalone: true,
})

export class MoveInComponent implements OnInit {
  readonly usStates: string[] = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS',
    'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY',
    'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV',
    'WI', 'WY'
  ];
  orderTypeDropdownOptions: string[] = [];
  reconnectSelectedDate: Date | null = null;
  reconnectformatedDate: string | null = null;
  isReconnect: boolean = false;
  orderTypeSelectedValue: string = '';
  StateDropdownOptions: any;
  getAllCity: any;
  stateSelectedValue: string = '';
  CityDropdownOptions: any;
  citySelectedValue: string = '';
  isLoading: boolean = true;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  cityNamePayLoad!: CityLoadData[];
  orderTypePayLoad!: OrderTypeData[];
  requestPayload!: RequestPayload;
  buildingDropdownOptions: { key: string, value: string }[] = [];
  buildingSelectedValue: string = '';
  leakedDropdownOptions: { key: string, value: string }[] = [];
  leakedSelectedValue: string = '';
  showDiv: boolean = false;
  isRightPanel: boolean = false;
  isPageLoad: boolean = true;
  isFirstLoad: boolean = true;
  isCity: boolean = false;
  cityValue: string = '';
  isCityText: boolean = false;
  submitted: boolean = false;
  isCustomClass: boolean = false;
  callerType: boolean = false;
  advisoriesData: any[] | undefined;
  passedByData: any[] | undefined;
  otherData: any[] | undefined;
  activeTabIndex: number = 0;
  isPopupVisible: boolean = false;
  isModalOpen: boolean = false;
  firstName: string = '';
  lastName: string = '';
  houseNumber: string = '';
  street: string = '';
  zip: string = '';
  phone: string = '';
  extension: string = '';
  accountno: string = '';
  ssn: string = '';
  dialogVisible: boolean = false;
  textboxStyle: string = 'textboxStyle';
  errorList: string[] = [];
  isValidate: boolean = false;
  SaveValidation: string = environment.appMessages.SaveValidation;
  saveSuccess: string = '';
  isSaveSuccess: boolean = false;
  isFormSubmitted: boolean = false;
  isSaveDisable: boolean = true;
  isSsnEnable: boolean = false;
  isCityValidate: boolean = false;
  newHouseNumber: string = '';
  newStreet: string = '';
  newCityValue: string = '';
  newStateSelectedValue: string = '';
  newZip: string = '';
  isNewCityText: boolean = false;
  isNewCity: boolean = true;
  meterNumber: string = '';
  installationNumber: string = '';
  serviceBeginDate: Date | null = null;
  driverLicenseState: string = '';
  driverLicenseNumber: string = '';
  maritalStatus: string = '';
  maritalStatusOptions: any[] = [
    { label: '', value: '' },
    { label: 'Single', value: 'SINGLE' },
    { label: 'Married', value: 'MARRIED' },
    { label: 'Divorced', value: 'DIVORCED' },
    { label: 'Widowed', value: 'WIDOWED' }
  ];
  setupInSpouseName: string = 'No';
  setSpouseName = ['Yes', 'No'];
  setSpouseGender = ['Mr', 'Ms'];
  badDebtTypes = ['Yes', 'No'];
  spouseLastName: string = '';
  spouseFirstName: string = '';
  spouseSSN: string = '';
  spouseGender: string = '';
  spouseMiddleInitial: string = '';
  spouseDateOfBirth: Date | null = null;
  automaticBankDraft = false;
  averageMonthlyBilling = false;
  elderlyDisabled = false;
  budgetPlan = false;
  badDebt: 'Yes' | 'No' = 'No';
  depositAmount: number = 0;
  comments: string = ''
  @ViewChild('formRef1') formRef1!: NgForm;
  @Output() formDataChange = new EventEmitter<any>();
  @Input() existingData: any = {}
  NewSvcCity: any;
  NewState: any;
  ateSvcToBeginDt: any;
  DateSvcToBeginDt: any;
  NewMeterNumber: any;
  excisting: any;
  NewInstallationNumber: any;
  DriverLicenseState: any;
  DriverLicenseNumber: any;
  MaritalStatus!: string;
  SetUpInSpouseName: any;
  SpouseSSN: any;
  SpouseLastName: any;
  SpouseFirstName: any;
  IsAutomaticBankDraft: any;
  IsAverageMonthlyBilling: any;
  IsElderlyDisabled: any;
  IsBudgetPlan: any;
  IsBadDebtAtPremise!: string;
  DepositAm: any;
  Spouse_MR_MS: any;
  inputNumberMode: string = 'decimal';

  constructor(private formBuilder: FormBuilder, private orderEntryService: OrderEntryService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private monotoringService: MyMonitoringService,
    private datePipe: DatePipe,
    private apiService: ApiService,
    private orderEntrySharedService: OrderEntrySharedService
  ) {
    this.requestPayload = new RequestPayload(
      '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', new Date(), '', '', '', '', '', '', '', '', '', '', '', '', ''
    );
  }


  ngOnInit(): void {
    this.LoadCityData();
    this.showDiv = false;
    this.isPageLoad = false;
    this.isCity = false;
    this.isCityText = false;
    this.GetOrderType();
    this.isSuccess = false;
    this.isSaveSuccess = false;
  }

  LoadCityData(): void {
    this.orderEntrySharedService.cityData.subscribe({
      next: (data: { Payload: CityLoadData[]; }) => {
        this.cityNamePayLoad = data.Payload
        this.CityDropdownOptions = this.cityNamePayLoad.filter(option => option.State.toLowerCase().includes(this.existingData?.NewState.toLowerCase()))
          .map(option => option.City);
        this.newCityValue = this.existingData?.NewSvcCity;
        this.isSuccess = true;
      }
    });
  }

  GetOrderType(): void {
    this.orderEntrySharedService.orderTypeData.subscribe({
      next: (data: { Payload: OrderTypeData[]; }) => {
        this.orderTypePayLoad = data.Payload
        this.orderTypeDropdownOptions = this.orderTypePayLoad.filter(item => item.Code === 'OrderType').map(item => item.Value)
          .sort((a, b) => a.localeCompare(b));

        this.StateDropdownOptions = ControlUtils.buildDropDownOptions(this.orderTypePayLoad.filter(item => item.Code === 'State').map(item => item.Value)
          .sort((a, b) => a.localeCompare(b)));
        this.isSuccess = true;
        this.isNewCity = false;
        this.isNewCityText = false;
        this.newHouseNumber = this.existingData?.NewHouseNumber;
        this.newStreet = this.existingData?.NewStreet;
        this.newCityValue = this.existingData?.NewSvcCity;
        this.newStateSelectedValue = this.existingData?.NewState;
        this.newZip = this.existingData?.NewZip;
        this.serviceBeginDate = ![null, undefined]?.includes(this.existingData?.WorkDt) ? new Date(this.existingData?.WorkDt) : null
        this.meterNumber = this.existingData?.NewMeterNumber;
        this.installationNumber = this.existingData?.NewInstallationNumber;
        this.driverLicenseState = this.existingData?.DriverLicenseState;
        this.driverLicenseNumber = this.existingData?.DriverLicenseNumber;
        this.maritalStatus = this.existingData?.MaritalStatus;
        this.setupInSpouseName = this.existingData?.SetUpInSpouseName;
        this.spouseSSN = this.existingData?.SpouseSSN == null ? "" : this.existingData?.SpouseSSN.toString();
        this.spouseLastName = this.existingData?.SpouseLastName;
        this.spouseFirstName = this.existingData?.SpouseFirstName;
        this.IsBadDebtAtPremise = this.existingData?.IsBadDebtAtPremise;
        this.badDebt = this.existingData?.IsBadDebtAtPremise;
        this.comments = this.existingData?.Comments;
        this.depositAmount = this.existingData?.DepositAm.toString();
        this.setSpouseGender = this.existingData?.Spouse_MR_MS;
        this.automaticBankDraft = this.existingData?.IsAutomaticBankDraft === "Yes";
        this.averageMonthlyBilling = this.existingData?.IsAverageMonthlyBilling === "Yes";
        this.elderlyDisabled = this.existingData?.IsElderlyDisabled === "Yes";
        this.budgetPlan = this.existingData?.IsBudgetPlan === "Yes";
      }
    });
  }

  validateForm(isFormSubmitted: boolean): boolean {
    if (!this.formRef1) {
      return false;
    }

    if (this.formRef1.valid) {
      return true;
    }

    if (!isFormSubmitted) {
      return false;
    }

    this.isFormSubmitted = isFormSubmitted;

    if (this.formRef1.invalid) {
      Object.keys(this.formRef1.controls).forEach(key => {
        const control = this.formRef1.controls[key];
        control.markAsTouched();
      });

      this.markCustomInputsAsTouched();
      return false;
    }

    // Additional validation for specific fields
    if (!this.newHouseNumber || !this.newStreet || !this.serviceBeginDate) {
      return false;
    }

    if (!this.newCityValue && !this.isNewCityText) {
      return false;
    }

    if (this.setupInSpouseName === 'Yes' && (!this.spouseLastName || !this.spouseFirstName)) {
      return false;
    }

    this.emitFormData();
    return true;
  }


  emitFormData() {
    const formData = {
      orderType: this.orderTypeSelectedValue,
      firstName: this.firstName,
      lastName: this.lastName,
      houseNumber: this.houseNumber,
      street: this.street,
      NewHouseNumber: this.newHouseNumber,
      NewStreet: this.newStreet,
      NewSvcCity: this.newCityValue,
      NewState: this.newStateSelectedValue,
      NewZip: this.newZip,
      NewMeterNumber: this.meterNumber,
      NewInstallationNumber: this.installationNumber,
      SvcToBeginDt: this.serviceBeginDate,
      DriverLicenseState: this.driverLicenseState,
      DriverLicenseNumber: this.driverLicenseNumber,
      MaritalStatus: this.maritalStatus,
      SetUpInSpouseName: this.setupInSpouseName,
      SpouseLastName: this.spouseLastName,
      SpouseFirstName: this.spouseFirstName,
      SpouseSSN: this.spouseSSN,
      Spouse_MR_MS: this.spouseGender,
      IsAutomaticBankDraft: this.automaticBankDraft ? "Yes" : "No",
      IsAverageMonthlyBilling: this.averageMonthlyBilling ? "Yes" : "No",
      IsElderlyDisabled: this.elderlyDisabled ? "Yes" : "No",
      IsBudgetPlan: this.budgetPlan ? "Yes" : "No",
      IsBadDebtAtPremise: this.badDebt,
      DepositAm: this.depositAmount,
      Comments: this.comments
    };
    this.formDataChange.emit(formData);
  }

  onDateChange(event: any) {
    this.reconnectSelectedDate = event;
    this.reconnectformatedDate = this.datePipe.transform(this.reconnectSelectedDate, 'MM/dd/yyyy');
  }

  getFormattedData = (arr: any) => {
    const tempArr = [{ label: 'All', value: 'all' }]
    return [...tempArr, ...arr?.map((item: any) => ({ label: item, value: item?.toString()?.toLowerCase() }))];
  }

  handleTabChange(event: any) {
    this.activeTabIndex = event.index;
  }


  onTextChange(input: any) {
  }

  onFirstNameChange(input: any) {
    this.firstName = input;
  }

  onLasttNameChange(input: any) {
    this.lastName = input;
  }

  onHouseNoChange(input: any) {
    this.houseNumber = input;
  }

  onStreetChange(input: any) {
    this.street = input;
  }

  onCityTextChange(input: any) {
    this.cityValue = input;
    this.isCityValidate = true;
  }

  onZipChange(input: any) {
    this.zip = input;
  }

  onPhoneChange(input: any) {
    this.phone = input;
  }

  onExtNoChange(input: any) {
    this.extension = input;
  }

  onAccNoChange(input: any) {
    this.accountno = input;
  }
  onSSNChange(input: any) {
    this.ssn = input;
  }

  onSpouseGenderChange(event: any) {
    this.spouseGender = event;
    this.emitFormData();
  }


  onNewHouseNoChange(input: string) {
    this.newHouseNumber = input;
    this.emitFormData();
  }

  onNewStreetChange(input: string) {
    this.newStreet = input;
    this.emitFormData();
  }

  onNewCityTextChange(input: string) {
    this.newCityValue = input;
    this.emitFormData();
  }

  OnNewStateChanged(event: string) {
    this.newStateSelectedValue = event;
    this.CityDropdownOptions = ControlUtils.buildDropDownOptions(this.cityNamePayLoad
      .filter(option => option.State.toLowerCase().includes(event.toLowerCase()))
      .map(option => option.City));
    this.isNewCity = false;
    this.isNewCityText = false;
    this.newCityValue = '';
    this.emitFormData();
  }

  OnNewCityChanged(event: string) {
    this.newCityValue = event;
    this.emitFormData();
  }

  onNewZipChange(input: string) {
    this.newZip = input;
    this.emitFormData();
  }

  onMeterNumberChange(input: string) {
    this.meterNumber = input;
    this.emitFormData();
  }

  onInstallationNumberChange(input: string) {
    this.installationNumber = input;
    this.emitFormData();
  }

  onServiceBeginDateChange(event: Date) {
    this.serviceBeginDate = event;
    this.emitFormData();
  }

  onDriverLicenseStateChange(event: string) {
    this.driverLicenseState = event;
    this.emitFormData();
  }

  onDriverLicenseNumberChange(input: string) {
    this.driverLicenseNumber = input;
    this.emitFormData();
  }

  onMaritalStatusChange(event: string) {
    this.maritalStatus = event;
    this.emitFormData();
  }

  onSpouseSetupChange(event: any) {
    this.setupInSpouseName = event;
    this.emitFormData();
  }

  onSpouseLastNameChange(input: string) {
    this.spouseLastName = input;
    this.emitFormData();
  }

  onSpouseFirstNameChange(input: string) {
    this.spouseFirstName = input;
    this.emitFormData();
  }

  onSpouseSSNChange(input: string) {
    this.spouseSSN = input;
    this.emitFormData();
  }

  onSpouseMiddleInitialChange(input: string) {
    this.spouseMiddleInitial = input;
    this.emitFormData();
  }

  onSpouseDateOfBirthChange(event: Date) {
    this.spouseDateOfBirth = event;
    this.emitFormData();
  }

  onCheckboxChange(event: any) {
    this.emitFormData();
  }

  onOrderType(event: any) {
    var OrderTypeValue = event.trim().toLowerCase();
    const data = OrderTypeValue.substring(0, 3);
    const filters = ['eme', 'obw'];
    this.isSsnEnable = !filters.includes(data);
    this.isReconnect = event.includes('RECONNECT')
    this.orderTypeSelectedValue = event;
    this.showDiv = false;
    this.isPageLoad = true
    this.isCustomClass = true;
    this.isSaveDisable = false;
  }

  showDialog() {
    this.dialogVisible = true;
  }


  resetFormValues() {
    this.newHouseNumber = '';
    this.newStreet = '';
    this.newCityValue = '';
    this.newStateSelectedValue = '';
    this.newZip = '';
    this.meterNumber = '';
    this.installationNumber = '';
    this.driverLicenseState = '';
    this.driverLicenseNumber = '';
    this.maritalStatus = '';
    this.setupInSpouseName = '';
    this.spouseSSN = '';
  }

  markCustomInputsAsTouched() {
    const customInputs = document.querySelectorAll('app-textinput');
    customInputs.forEach((input) => {
      (input as any).markAsTouched?.();
    });
  }

  onSubmit(formValue: any) {
    this.isFormSubmitted = true;
    if (formValue.invalid) {
      Object.keys(formValue.controls).forEach((key) => {
        formValue.controls[key].markAsTouched();
      });
      this.markCustomInputsAsTouched();
      return;
    }

    if (this.ssn != null || this.ssn !== '') {
      this.ssn = this.ssn.replaceAll('-', '');
    }

    if (this.phone != null || this.phone !== '') {
      this.phone = this.phone.replaceAll('-', '').replaceAll('(', '').replaceAll(')', '');
    }

    if (this.reconnectformatedDate != null || this.reconnectformatedDate !== '') {
      this.requestPayload.reqReconnectDt = this.reconnectSelectedDate;
    }
    else {
      this.requestPayload.reqReconnectDt = null;
    }
    this.requestPayload.reconnectApptTm = '';
    this.requestPayload.orderType = this.orderTypeSelectedValue;
    this.requestPayload.firstName = this.firstName;
    this.requestPayload.lastName = this.lastName;
    this.requestPayload.houseNumber = this.houseNumber;
    this.requestPayload.street = this.street;
    this.requestPayload.city = "";
    this.requestPayload.state = "";
    this.requestPayload.zip = this.zip;
    this.requestPayload.gender = formValue.value.gender;
    this.requestPayload.safePhone = this.phone;
    this.requestPayload.extension = this.extension;
    this.requestPayload.contractAccountNo = this.accountno;
    this.requestPayload.ssn = this.ssn;
    this.requestPayload.customerRequestInformation = formValue.value.customerRequest;
    this.requestPayload.newCity = ""

    this.requestPayload.newStreet = ""
    this.requestPayload.newCityValue = this.newCityValue;
    this.requestPayload.newStateSelectedValue = this.newStateSelectedValue;

    this.requestPayload.newZip = this.newZip;
    this.requestPayload.meterNumber = this.meterNumber;
    this.requestPayload.installationNumber = this.installationNumber;
    this.requestPayload.driverLicenseState = this.driverLicenseState;
    this.requestPayload.driverLicenseNumber = this.driverLicenseNumber;
    this.requestPayload.maritalStatus = this.maritalStatus;
    this.requestPayload.setupInSpouseName = this.setupInSpouseName;
    this.requestPayload.spouseSSN = this.spouseSSN;


    this.requestPayload.newHouseNumber = this.newHouseNumber;
    this.requestPayload.newStreet = this.newStreet;

    if (this.orderTypeSelectedValue === "MOVE-IN") {
      this.saveOldCustomerData(this.requestPayload);

    } else {
      this.saveCustomerData(this.requestPayload);
    }
  }

  orderTypDataChange(event: any) {
    this.orderTypeSelectedValue = event;
    this.showDiv = true;
    this.isPageLoad = true
    this.isCustomClass = true;
  }

  OnbuildingChanged(event: any) {
    this.buildingSelectedValue = event.target.value;
  }

  OnleakedChanged(event: any) {
    this.leakedSelectedValue = event.target.value;
  }

  OnStateChanged(event: any) {
    this.stateSelectedValue = event;
    this.CityDropdownOptions = this.cityNamePayLoad.filter(option => option.State.toLowerCase().includes(event.toLowerCase()))
      .map(option => option.City);
    this.isCity = true;
    this.isCityText = false;
  }

  OnCityChanged(event: any) {
    this.citySelectedValue = event;
    this.isCityValidate = true;
  }

  orderTypChanged() {
    this.showDiv = true;
    this.isPageLoad = true
  }

  cityClick() {
    this.isCityText = true;
  }


  onbadDebtChange(event: any) {
    this.badDebt = event;
    this.emitFormData();
  }

  onPageLoad() {
    window.location.reload();
  }

  saveCustomerData(request: any): void {
    this.orderEntryService.saveCustomerData(request).subscribe({
      next: (data: any) => {

        this.isSuccess = true;
        this.isSaveSuccess = true;
        if (data.Payload == 'RecordExist') {
          this.saveSuccess = environment.appMessages.RecordExist + this.orderTypeSelectedValue + ' order.';
        }
        else {
          this.saveSuccess = environment.appMessages.saveSuccess + this.orderTypeSelectedValue + ' order.';
        }
      },
      error: (error: string) => {
        this.isLoading = false;
        this.isFailure = true;
        this.isSaveSuccess = false;
        this.monotoringService.logException({ name: 'MoveInComponent.saveCustomerData', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  saveOldCustomerData(request: any): void {
    this.orderEntryService.saveOldCustomerData(request).subscribe({
      next: (data: any) => {

        this.isSuccess = true;
        this.isSaveSuccess = true;
        if (data.Payload == 'RecordExist') {
          this.saveSuccess = environment.appMessages.RecordExist + this.orderTypeSelectedValue + ' order.';
        }
        else {
          this.saveSuccess = environment.appMessages.saveSuccess + this.orderTypeSelectedValue + ' order.';
        }
      },
      error: (error: string) => {
        this.isLoading = false;
        this.isFailure = true;
        this.isSaveSuccess = false;
        this.monotoringService.logException({ name: 'MoveInComponent.saveOldCustomerData', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onOrderTypeChange(event: any): void {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      return;
    }
    this.showDiv = true;
    this.isPageLoad = true
  }

  onReset(): void {
    this.submitted = false;
  }

  customerClicked(): void {
    this.isRightPanel = true;
    this.callerType = true;
    this.isPopupVisible = true;
  }

  passedByClicked(): void {
    this.isRightPanel = true;
    this.callerType = true;
    this.isPopupVisible = true;
  }

  otherClicked(): void {
    this.isRightPanel = true;
    this.callerType = true;
    this.isPopupVisible = true;
  }

  onConfirm() {
    console.log('Item deleted');
    this.isPopupVisible = false;
  }

  onCancel() {
    console.log('Action canceled');
    this.isPopupVisible = false;
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  handleFormValuesChange(values: any) {
    this.reconnectSelectedDate = values.reconnectSelectedDate;
    this.reconnectformatedDate = values.reconnectformatedDate;
  }

  onDepositAmountChange(amount: any) {
    this.depositAmount = amount.toString();
    this.emitFormData();
  }


  onCommentsChange(event: Event) {
    console.log(">>event", (event.target as HTMLTextAreaElement).value)
    this.comments = (event.target as HTMLTextAreaElement).value;
    this.emitFormData();
  }


}
